export default {
  noc: {
    buttons: {
      support: 'ساپورت',
      issueList: 'لیست حل مشکل',
      installationList: 'لیست حل انستالیشن',
      callHistory: 'مشاهد سابقه تماس ها',
      missionList: 'لیست ماموریت ها',
      tasks: 'تسک ها',
    },
    calls: {
      addRecord: 'ثبت تماس جدید',
      editRecord: 'ویرایش تماس',
      reasonTitle: 'دلیل تماس',
      reasonPlaceholder: 'انتخاب دلیل تماس',
      noteTitle: 'نوت',
      dateTitle: 'تاریخ',
      submit: 'ثبت',
      deleteTitle: 'حذف سابقه تماس',
      deleteDescription: 'آیا مطمئن هستید که می‌خواهید این سابقه تماس را حذف کنید؟',
      deleteConfirm: 'حذف',
      deleteCancel: 'کنسل',
    },
      missions: {
      title: 'لیست ماموریت ها',
      addMission: 'ثبت ماموریت جدید',
      editMission: 'ویرایش ماموریت',
      emptyToday: 'امروز ماموریتی ثبت نشده است',
      fields: {
        date: 'تاریخ',
        user: 'نام کارمند',
        missionType: 'نوع ماموریت',
        status: 'وضعیت',
        location: 'موقعیت',
        customerName: 'نام مشتری',
        equipment: 'تجهیزات استفاده شده',
        note: 'نوت',
        cost: 'سفر خرج',
      },
      statusOptions: {
        pending: 'در انتظار',
        inProgress: 'در حال انجام',
        done: 'انجام شده',
      },
      typeOptions: {
        installation: 'انستالیشن',
        troubleshooting: 'حل مشکل',
        siteSurvey: 'سایت سروی',
        other: 'غیره',
      },
      actions: {
        save: 'ثبت',
        cancel: 'کنسل',
        delete: 'حذف',
      },
      deleteTitle: 'حذف ماموریت',
      deleteDescription: 'آیا مطمئن هستید که می‌خواهید این ماموریت را حذف کنید؟',
    },
    cards: {
      tasks: {
        title: 'تسک های ترانز میشن و ماموریت ها',
      },
      equipment: {
        title: 'ویجت تجهیزات استفاده شده',
        empty: 'امروز تجهیزاتی ثبت نشده است',
      },
      calls: {
        title: 'ویجت سابقه تماس',
        totalCalls: 'تعداد تماس ها',
        technicalIssue: 'مشکل تخنیکی',
        recharge: 'ریچارج',
        disconnect: 'قطعی',
        other: 'غیره',
      },
      todayInstallations: {
        title: 'تعداد انستالیشن های امروز',
        installed: 'نصب شده ها',
        canceled: 'کنسل شده ها',
        postponed: 'تعویق افتاد',
        issuesTitle: 'تعداد حل مشکلات',
        solved: 'حل شده',
        deferred: 'تعویق افتاده',
        unsolved: 'حل نشده',
      },
      teamActivity: {
        title: 'فعالیت تیم',
        calls: 'تماس ها',
        tickets: 'تیکت ها',
        installations: 'انستالیشن ها',
      },
    },
    defaultTitle: 'داشبورد',
    defaultMessage: 'برای این نقش داشبورد مخصوص هنوز ساخته نشده است.',
  },
}
